import React, {useContext, useEffect, useState} from "react";
import {SettingsContext} from "/src/SettingsContext";
import {useLocation, useParams} from "react-router-dom";

import {useTranslation} from "react-i18next";
import i18n from "i18next";
import axiosInstance from "../../../axiosInstance";
import {useOverlay} from "@/OverlayContext";
import Cookies from "js-cookie";
import { showMultiLingualText } from "@/utils/LanguageUtils";
import { ToursContext } from "@/ToursContext";

export default function InventoryList({ onContentLoaded }) {

    const { tourSettings } = useContext(SettingsContext);
    const params = useParams();
    const location = useLocation();
    const { t } = useTranslation();
    const [inventory, setInventory] = useState({});
    const { activeTour } = useContext(ToursContext);
    const quantityThreshold = 5;

    const { setOverlayTitle } = useOverlay();

    useEffect(() => {
        // Track page view
        var _paq = window._paq = window._paq || [];
        _paq.push(['setCustomUrl', location.pathname]);
        _paq.push(['setDocumentTitle', 'Inventory']);
        _paq.push(['trackPageView']);
    }, [location]);

    React.useEffect (() => {
        console.log('Inventory component mounted');
        console.log("Language from URL params:", params, params.language);
        console.log(tourSettings);

        // fetch page details
        if (tourSettings) {
            loadContent();
        }

    }, [tourSettings, i18n.language, onContentLoaded]);

    const loadContent = () => {
        // Load inventory from cookies
        const loadInventory = async () => {
            const inventoryCookie = Cookies.get('inventory');
            if (inventoryCookie) {
                try {
                    const parsedInventory = JSON.parse(inventoryCookie);
                    console.log("parsedInventory1", parsedInventory);
                    console.log("load Inventory based on cookie");
                    let headers = {
                        ...(activeTour && {
                            "X-Tour-Id": activeTour
                        }),
                    }
                    const response = await axiosInstance.get(process.env.CLIENT_API_URL + "/client/game/object-items", {headers: headers}) // get tour points
                   if (response.status !== 200) {
                        console.error('Error loading inventory:', response.data);
                        setInventory({});
                        return;
                   }

                    const inventory = response.data;
                    console.log("response", inventory);

                    // Convert parsedInventory to array if it's an object
                    const inventoryItems = Array.isArray(parsedInventory) 
                        ? parsedInventory 
                        : Object.values(parsedInventory);

                    // Create a new object to store the updated inventory
                    const updatedInventory = {};

                    // Process each item
                    for (const item of inventoryItems) {
                        const inventoryItem = Object.values(inventory).find(invItem => invItem.id === item.object_id);
                        if (inventoryItem) {
                            updatedInventory[item.object_id] = {
                                object: inventoryItem,
                                quantity: item.quantity
                            };
                        }
                    }

                    console.log("parsedInventory2", updatedInventory);

                    setInventory(updatedInventory);
                } catch (e) {
                    console.error('Error parsing inventory cookie:', e);
                    setInventory({});
                }
            }
        };

        loadInventory();

        try {
            setOverlayTitle(showMultiLingualText(tourSettings?.game?.inventory_title, t('game.inventory')));
            if (onContentLoaded) {
                onContentLoaded();
            }
        } catch (error) {
            console.error('Error loading content:', error);
        }
    }

    return (
        <div className="p-4">
            
            {Object.keys(inventory).length === 0 ? (
               <p className="text-gray-500">{showMultiLingualText(tourSettings?.game?.inventory_empty_description, t('game.inventory_empty_description'))}</p>
            ) : (
                <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-3">
                    {Object.values(inventory).map((item, index) => (
                        item.quantity > 0 && (
                            item.quantity > quantityThreshold ? (
                                // For items with quantity > threshold, show one icon with badge
                                <div key={index} className="relative group">
                                    <img
                                        src={item.object.image.preview_url}
                                        alt={item.object.name}
                                        title={`${item.object.name} (${item.quantity})`}
                                        className="w-16 h-16 object-contain mx-auto"
                                    />
                                    <div
                                        className="absolute -top-2 -right-2 text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center"
                                        style={{
                                            "backgroundColor": `${tourSettings.contrast_color}`,
                                            "color": `${tourSettings.contrast_text_color}`
                                        }}
                                    >
                                        {item.quantity}
                                    </div>
                                    <div
                                        className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-xs text-center rounded py-1 px-2 w-full max-w-40"
                                        style={{
                                            "backgroundColor": `${tourSettings.theme_color}`,
                                            "color": `${tourSettings.theme_text_color}`,
                                            "overflow": "hidden",
                                            "textOverflow": "ellipsis",
                                            "whiteSpace": "nowrap"
                                        }}>
                                        {item.object.name}
                                    </div>
                                </div>
                            ) : (
                                // For items with quantity <= threshold, show multiple icons
                                [...Array(item.quantity)].map((_, i) => (
                                    <div key={`${index}-${i}`} className="relative group">
                                        <img
                                            src={item.object.image.preview_url}
                                            alt={item.object.name}
                                            title={item.object.name}
                                            className="w-16 h-16 object-contain mx-auto"
                                        />
                                        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-xs text-center rounded py-1 px-2 w-full max-w-40"
                                          style={{
                                            "backgroundColor": `${ tourSettings.theme_color }`, 
                                            "color": `${ tourSettings.theme_text_color }`,
                                            "overflow": "hidden",
                                            "textOverflow": "ellipsis",
                                            "whiteSpace": "nowrap"
                                          }}>
                                            {item.object.name}
                                        </div>
                                    </div>
                                ))
                            )
                        )
                    ))}
                </div>
            )}
        </div>
    );
}
